import React, { FC } from 'react';
import { Route } from 'react-router-dom';
import PrivateLayout from '../layouts/PrivateLayout';
import { connect } from 'react-redux';
import RedirectToLogin from './RedirectToLogin';

const CompleteProfileRoute: FC<{
  component: FC;
  path: string;
  exact?: boolean;
  loginState;
  roleState;
  isAdmin: boolean;
}> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { path, exact, ...rest } = props;
  const Component = props.component;

  const { isUserAuthenticated, isWaitingForAPIResponse } = props.loginState;

  return (
    <>{!isWaitingForAPIResponse ? isUserAuthenticated ? (
      <Route
        path={path}
        exact={exact}
        render={(renderProps) => (
          <PrivateLayout>
            <Component {...renderProps} />
          </PrivateLayout>
        )}
      />) : <RedirectToLogin /> : <></>}
    </>
  );
};

const mapStateToProps = ({ loginReducer }) => ({
  loginState: loginReducer.loginState,
  roleState: loginReducer.roleState,
  isAdmin: loginReducer.loginState.isAdmin,
});

export default connect(mapStateToProps)(CompleteProfileRoute);
